import React, { useEffect, useState } from 'react';
import Card from 'components/Card/Card';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import style from 'assets/jss/material-dashboard-pro-react/views/contactUs/queriesAndComplaintsStyle';
import CardBody from 'components/Card/CardBody';
import { BodyS, HeadingLBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import SingleTabButton from './components/SingleTabButton';
import { ReactComponent as RegisterTicketIcon } from 'assets/img/icons/register-ticket.svg';
import { ReactComponent as TrackTicketIcon } from 'assets/img/icons/track-ticket.svg';
import { ReactComponent as QueriesAndComplaintsIcon } from 'assets/img/icons/queries_and_complaints.svg';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import RegisteringComplaint from './components/RegisteringComplaint';
import TicketTracking from './components/TicketTracking';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { getLanguage } from 'utils/language/language';
import { useSelector } from 'react-redux';
import { upIdSelector } from 'redux/modules/session/selectors';

enum SELECTED_TAB {
	REGISTER_TICKET,
	TRACK_TICKET,
}

// @ts-ignore
const useStyles = makeStyles(style);

const QueriesAndComplaints = () => {
	const classes = useStyles();
	const [ticketId, setTicketId] = useState('');
	const [selectedTab, setSelectedTab] = useState<SELECTED_TAB | null>(null);
	const accId = useSelector(upIdSelector);

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		const ticketNumber = queryParams.get('ticketNumber');

		setTicketId(ticketNumber ?? '');
		setSelectedTab(ticketNumber?.replace(/\W/g, '').length ? SELECTED_TAB.TRACK_TICKET : null);
	}, []);

	const tabChanged = (tab: SELECTED_TAB) => {
		setDataLayer('support_query_type', getLanguage(), null, accId, null, {
			link_name:
				tab == SELECTED_TAB.REGISTER_TICKET
					? translate('contact.us.queries.and.complaints.register.ticket')
					: translate('contact.us.queries.and.complaints.track.ticket'),
		});
		setSelectedTab(tab);
	};

	return (
		<div className={classes.queriesComplaints}>
			<div className={classes.queriesComplaintsIconContainer}>
				<Card className={classes.card}>
					<div className={classes.iconContainer}>
						<QueriesAndComplaintsIcon className={classNames(classes.mail, classes.icon)} />
					</div>
				</Card>
			</div>
			<div className={classes.queriesComplaintsColumn}>
				<Card className={classes.card}>
					<CardBody className={classes.cardBody}>
						<HeadingLBold color="primary-light" disableMargin>
							{translate('contact.us.queries.and.complaints')}
						</HeadingLBold>
						<div className={classes.queriesComplaintsTextWrapper}>
							<BodyS disableMargin color="primary-light">
								{translate('contact.us.queries.complaint.description')}
							</BodyS>
						</div>
						<div className={classes.queriesComplaintsButtons}>
							<SingleTabButton
								icon={<RegisterTicketIcon />}
								text={translate('contact.us.queries.and.complaints.register.ticket')}
								onClick={() => tabChanged(SELECTED_TAB.REGISTER_TICKET)}
								active={selectedTab === SELECTED_TAB.REGISTER_TICKET}
							/>
							<SingleTabButton
								icon={<TrackTicketIcon />}
								text={translate('contact.us.queries.and.complaints.track.ticket')}
								onClick={() => tabChanged(SELECTED_TAB.TRACK_TICKET)}
								active={selectedTab === SELECTED_TAB.TRACK_TICKET}
							/>
						</div>
					</CardBody>
				</Card>
				<ConditionalRender
					show={selectedTab === SELECTED_TAB.TRACK_TICKET}
					onTrue={() => (
						<Card className={classes.cardTicket}>
							<TicketTracking ticketNumber={ticketId} />
						</Card>
					)}
				/>
				<ConditionalRender
					show={selectedTab === SELECTED_TAB.REGISTER_TICKET}
					onTrue={() => (
						<Card className={classes.cardTicket}>
							<RegisteringComplaint />
						</Card>
					)}
				/>
			</div>
		</div>
	);
};

export default QueriesAndComplaints;
